import { Component, Input } from '@angular/core';
import { FabricComposition } from '../../../models/greige/greige';

@Component({
  selector: 'app-card-composition',
  templateUrl: './card-composition.component.html',
  styleUrl: './card-composition.component.scss',
})
export class CardCompositionComponent {
  @Input() fabricComposition: FabricComposition[] = [];

  getCompositionColor(catClave: string): string {
    switch (catClave.toLowerCase()) {
      case 'cotton':
        return '#001a70';
      case 'poly':
        return '#ef4444';
      case 'recycledblackpoly':
        return '#5fa535';
      case 'rayon':
        return '#009999';
      case 'blackpoly':
        return '#5AA29D';
      case 'polyrecycle':
        return '#5AA29D';
      default:
        return '#777';
    }
  }
}
